import React from 'react'
import styled from 'styled-components'
import { deviceLessThan, deviceGreaterThan } from '../../styles/breakpoints';

/**
* Product List
*
*/

export const ProductListCard = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    border:${props => props.border && props.border};
    height:${props => props.height && props.height};
    min-height:${props=> props.minHeight && props.minHeight};
    padding:${props => props.padding && props.padding};
    width:${props => props.width && props.width};
    text-align:${props => props.align && props.align};
    cursor:${props => props.cursor && props.cursor};
    @media ${deviceLessThan.tablet} {
        width:${props => props.sWidth && props.sWidth};
        min-height:${props => props.sMinHeight && props.sMinHeight};
        padding:${props => props.sPadding && props.sPadding};
    }
`;

export const ProductListWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin:30px 0px 50px;
    &:hover a{
        text-decoration:none;
    }
    @media ${deviceLessThan.tablet} {
        margin:30px 0px 0px;
    }
`;

export const ProductListContainer = styled.div`
    padding:20px;
    margin:40px 0px 20px;
    @media ${deviceLessThan.tablet} {
        margin:20px 0px;
    }
`;